import React from "react";
import { Label } from "./ui/label";
import { cn } from "~/lib/utils";

interface IProps {
  label: string;
  children: React.ReactNode;
  className?: string;
}

const LabeledComponent = ({ label, children, className }: IProps) => {
  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <Label htmlFor="description">{label}</Label>
      {children}
    </div>
  );
};

export default LabeledComponent;
